import React, { useState } from 'react';
import Modal from '../shared/Modal';
import { SelectField, TextField, SegmentedField } from '../shared/FormField';
import { ECOLOGICAL_ZONES } from '../data/enums';
import { useLocationOptions } from '../shared/useLocationOptions';
import { geospatialApi } from '../../../api/geospatialApi';

const blank = { state: '', lga: '', ward: '', ecological_zone: '', coordinates: '' };

export default function CreateGeospatialModal({ isOpen, onClose, onCreate }) {
  const [form, setForm]         = useState(blank);
  const [status, setStatus]     = useState('idle');
  const [errMsg, setErrMsg]     = useState('');
  const [submitting, setSub]    = useState(false);
  const { stateOptions, lgaOptions, wardOptions, loadingLgas, loadingWards } = useLocationOptions(form.state, form.lga);

  const set = (k) => (v) => setForm((f) => {
    if (k === 'state') {
      return { ...f, state: v, lga: '', ward: '' };
    }
    if (k === 'lga') {
      return { ...f, lga: v, ward: '' };
    }
    return { ...f, [k]: v };
  });

  const submit = async () => {
    if (!form.state) return;

    setSub(true);
    try {
      const created = await geospatialApi.create(form);
      onCreate(created);
      setStatus('success');
    } catch (e) {
      const msg = e?.response?.data?.message ?? e.message ?? 'Failed to create geospatial record.';
      setErrMsg(msg);
      setStatus('error');
    } finally {
      setSub(false);
    }
  };

  const handleClose = () => {
    setForm(blank);
    setStatus('idle');
    setErrMsg('');
    onClose();
  };

  return (
    <Modal
      title="Create Geospatial Reference"
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={submit}
      status={status}
      errorMessage={errMsg}
      onContinue={handleClose}
      isSubmitting={submitting}
    >
      <SelectField
        label="State"
        required
        value={form.state}
        onChange={set('state')}
        options={stateOptions}
        placeholder="Select State"
      />
      <TextField
        label="LGA"
        value={form.lga}
        onChange={set('lga')}
        suggestions={lgaOptions}
        placeholder={form.state ? (loadingLgas ? 'Loading LGAs...' : 'Type or select LGA') : 'Select State first'}
        disabled={!form.state}
        note={form.state ? 'Type a new LGA or choose one from the live suggestions.' : 'Select a state first.'}
      />
      <TextField
        label="Ward"
        value={form.ward}
        onChange={set('ward')}
        suggestions={wardOptions}
        placeholder={form.state && form.lga ? (loadingWards ? 'Loading Wards...' : 'Type or select Ward') : 'Select LGA first'}
        disabled={!form.state || !form.lga}
        note={form.state && form.lga ? 'Type a new Ward or choose one from the live suggestions.' : 'Select an LGA first.'}
      />
      <SegmentedField label="Ecological Zone" value={form.ecological_zone} onChange={set('ecological_zone')} options={ECOLOGICAL_ZONES} />
      <TextField
        label="Coordinates"
        value={form.coordinates}
        onChange={set('coordinates')}
        placeholder="lat, lng  e.g. 6.4474, 3.4214"
      />
    </Modal>
  );
}
